export default {
    systemDb: {
        title: 'Tablero del Sistema',
        commandsTitle: 'Comandos Enviados',
        pingCommandsTitle: 'Pings Enviados',
        cmdPriorityTitle: 'Prioridades de Comando',
        throughputTitle: 'Rendimiento',
        CommandSuccess: 'Tasa de éxito',
        CommandCounts: 'Conteos de comandos',
        commandsSent: 'Comandos enviados',
        commandsCompleted: 'Comandos completadosd',
        successRate: 'Tasa de éxito %',
        rcdcSuccess: 'Eléctrica Conexión / desconexión remota correctaa',
        rcdcSuccessGraphLabel: 'Porcentaje',
        rcdcOverTime: 'Eléctrica Conexión / desconexión remota hora',
        rcdcOverTimeGraphLabel: 'Segundos promedio',
        CommandAverageTime: 'Sin amigo',
        CommandAverageTimeUsedBuddy: 'Usando un amigo',
        throughput: 'Rendimiento',
        throughputGraphLabel: 'Porcentaje',
        appCodesTitle: 'Mensajes de la Aplicación',
        uplinkCountsTitle: 'Mensajes de Ascendente',
        uplinkCounts: 'Mensajes de Ascendente',
        uplinkCountsGraphLabel: 'Contar',
        uplinkAirTime: 'Tiempo Aire de Ascendente',
        uplinkAirTimeGraphLabel: 'Segundos',
        frequencyCounts: 'Cuenta de Frecuencia',
        errorRetrievingFrequencyCounts : 'Error al recuperar datos de recuento de frecuencia',
        frequency: 'Frecuencia',
        snrTooltip: 'Los promedios diarios de la mejor ruta directa para cada radio',
        RIS: 'Rendimiento de lectura',
        Throughput: 'Rendimiento',
        SystemSNR: 'SNR del terminal',
        snr: 'SNR del terminal',
        snrGraphLabel: 'dB',
        city: 'Ciudad',
        cityRisThroughput: 'Rendimiento de lectura y Rendimiento por Ciudad',
        cityRisThroughputGraphLabel: 'Porcentaje',
        deviceSetRisThroughput: 'Rendimiento de lectura y rendimiento por Conjunto',
        lifeCycleRis: "Rendimiento de lectura por estado del ciclo de vida",
        lifeCycleRisGraphLabel: "Porcentaje",
        lifecycle: "Estado del Ciclo de Vida",
        set: 'Conjunto',
        deviceSetRisThroughputGraphLabel: 'Porcentaje',
        lowestCityThroughput: 'Rendimiento más bajo de la ciudad',
        lowestCityThroughputGraphLabel: 'Porcentaje',
        towerCount: 'Estación Base Conteo',
        radioCount: 'Radio Conteo',
        radioCounts: {
            supervisory: 'Supervisor Conteo',
            priority: 'Prioridad Conteo',
            candi: 'C&I Conteo',
            receive: 'Recibir Conteo',
            receiveb: 'Recibir B Conteo',
            boost: 'Aumentar Conteo'
        },
        readIntervalSuccess: 'Rendimiento de lectura',
        readIntervalSuccessGraphLabel: 'Porcentaje',
        UtilityRIS: "Utilidad rendimiento de lectura",
        SystemRIS: "Sistema rendimiento de lectura",
        NonZeroRIS: "Rendimiento de lectura mínimo",
        networkPerformance: 'Rendimiento de la red',
        readIntervalCollection: 'Colección de intervalos de lectura',
        billingReadCollection: 'Colección de lectura de facturación',
        networkHealth: 'Network Health Overview',
        towerRNIComms: "Descripción general de la salud de la red",
        offlineTowers: "Estaciones base/colectores fuera de línea",
        unheardTowers: "Estaciones base/colectores no escuchados",
        networkPulse: {
            issueCount: 'Actualmente {count} números',
            noIssues: 'Sin problemas'
        },
        builtinGroups: {
            networkPulse: 'Network Pulse',
            systemDefault: 'Sistema por defecto',
            customDashboard: 'Tablero personalizado',
        }
    }
}
